/**
 * Client-side permission helpers.
 * The server always enforces — this only drives UI show/hide.
 */

export type Role = 'super_admin' | 'admin' | 'technician' | 'sales_rep' | 'read_only'

export interface UserClaims {
  user_id: string
  email: string
  role: Role
  permissions: string[]
}

export function hasPermission(claims: UserClaims | null, key: string): boolean {
  return claims?.permissions.includes(key) ?? false
}

/** Nav module definition — permission key gates sidebar visibility. */
export interface NavModule {
  id: string
  label: string
  permissionKey: string
  path: string
}

/** Context passed from AppShell to child modules via React Router Outlet. */
export interface ShellContext {
  activeTab: number
  setActiveTab: (i: number) => void
  tabs: string[]
}

export const NAV_TOP: NavModule[] = [
  { id: 'dashboard',    label: 'Dashboard',    permissionKey: 'lead_engine.view',  path: '/app'         },
  { id: 'lead-engine',  label: 'Lead Engine',  permissionKey: 'lead_engine.view',  path: '/app/leads'   },
  { id: 'sales-engine', label: 'Sales Engine', permissionKey: 'deal_desk.view',    path: '/app/deals'   },
  { id: 'projects',     label: 'Projects',     permissionKey: 'project_mgmt.view', path: '/app/projects'},
  { id: 'service-desk', label: 'Service Desk', permissionKey: 'ticket.view',       path: '/app/tickets' },
  { id: 'intelligence', label: 'Intelligence', permissionKey: 'reporting.view',    path: '/app/reports' },
]

export const NAV_SETTINGS: NavModule = {
  id: 'settings', label: 'Settings', permissionKey: 'admin.users', path: '/app/admin',
}

export const MODULE_TABS: Record<string, string[]> = {
  'lead-engine':  ['Lead Finder', 'CRM', 'Marketing Automation', 'Website Signals', 'Routing Rules'],
  'sales-engine': ['Pipeline', 'Deal Desk', 'Forecast', 'Proposals', 'Assessments'],
  'projects':     ['My Work', 'Projects', 'Tasks', 'Timeline', 'Schedule', 'Reports'],
  'service-desk': ['Open', 'All Tickets', 'Board', 'Queues'],
  'intelligence': ['Analytics', 'Activity', 'Clients'],
  'settings':     ['General', 'Users & Roles', 'Integrations', 'Branding', 'Notifications', 'Service Catalog'],
}
